import { normalizeDonationHeader } from '@signalvote/shared';
import { cn } from '@/lib/utils';

interface DonationHeaderMessageProps {
  /** The campaign's optional appeal. Rendered as escaped plain text; blank renders nothing. */
  message: string | null | undefined;
  className?: string;
}

/**
 * The campaign admin's optional top-of-form personal appeal. Rendered as ESCAPED plain text — it is a
 * React text node, so a message containing `<b>` or other markup renders as literal characters, never
 * HTML (the public embed is not an injection surface). Newlines are preserved via `whitespace-pre-line`.
 * Renders NOTHING when the message is blank (empty / whitespace-only) — the empty state that shows no
 * header at all. Shared by the public donation form and the admin live preview so the two agree exactly.
 */
export function DonationHeaderMessage({ message, className }: DonationHeaderMessageProps) {
  const text = normalizeDonationHeader(message);
  if (text === null) {
    return null;
  }

  return (
    <p
      data-testid="donation-header-message"
      className={cn('whitespace-pre-line', className)}
    >
      {text}
    </p>
  );
}
